import {createSelector} from 'reselect';
import {getCardType} from '../CardOptionSelectors/CardOptionSelectors';
import {getSettings, getStart} from '../selectors';
import getIcon from '../../../sections/PaymentOptionsSection/PaymentOptions/paymentOptionSvgs';

const getCards = createSelector(
  [getStart, getSettings],
  (start, settings) => {
    if (start.paymentOptions
      && start.paymentOptions.cardTypes
      && start.paymentOptions.cardTypes.length > 0
      && settings.displayable_card_types_enabled) {
      return start.paymentOptions.cardTypes;
    }
    // Legacy migration code
    const wrapInCardTypesObject = name => ({name, display: true});
    if (window.acceptedCardTypes) {
      return window.acceptedCardTypes.split(',')
        .map(wrapInCardTypesObject);
    }
    
    return ['visa-credit', 'visa-debit', 'mastercard', 'maestro', 'amex', 'visa-electron']
      .map(wrapInCardTypesObject);
  },
);

const getCardsWithIcons = card => getIcon(card.name);

export const getDisplayableCards = createSelector(
  [getCards],
  cards => cards.filter(cardType => cardType.display).map(getCardsWithIcons),
);

export const getSupportedCards = createSelector(
  [getCards],
  cards => cards.map(getCardsWithIcons),
);

export const isCardTypeSupported = createSelector(
  [getSupportedCards, getCardType],
  (supportedCards, cardType) => (
    cardType.iconName !== ''
    && cardType.name !== 'unknown'
    && supportedCards.some(card => (card.name === cardType.iconName))
  ),
);
